<template>
  <form
    @submit.prevent="onSave">
    <fixed-header id="sticky-header">
      <div class="row form-header">
        <div class="col-sm-4 col-xl-4 m-auto">
          <a class="h6" href="javascript:void(0)"
            @click="onViewCandidate"
          >
            <i class="uil-arrow-left"></i> {{$t('common.back_to').toUpperCase()}} {{$t('candidate.singular').toUpperCase()}} 
          </a>
        </div>
        <div class="col-sm-8 col-xl-8 text-sm-right">
          
        </div>
        
      </div>
    </fixed-header>

    <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if='errorMessage'>
      {{errorMessage}}
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="card">
          <div class="card-title border-bottom p-3 mb-0 header-title">Profile</div>
          <div class="card-body">
            
              <div class="row">
                <div class="col-md-6 m-auto text-center">

                  <div class="avatar-upload">
                    <div class="avatar-edit">
                      <input 
                        type='file' 
                        id="imageUpload" 
                        @change="onAvatarChange"
                        accept=".png, .jpg, .jpeg" />
                      <label for="imageUpload"><i class="uil uil-pen"></i>  </label>
                    </div>
                    <div class="avatar-preview">
                      <img
                        ref="imagePreview"
                        src="@assets/images/users/avatar-7.jpg"
                        alt
                        class="avatar-xxl rounded-circle"
                      />
                    </div>
                  </div>

                </div>
                <div class="col-md-6 mt-2">
                  <TextField 
                    :placeholder="$t('candidate.form.first_name.placeholder')"
                    :label="$t('candidate.form.first_name.label') + '*'"
                    v-model="model.first_name"
                    :error="$v.model.first_name.$error"
                    :errorMessage="$v.model.first_name.errorMessage"
                  />
                  <TextField 
                    :placeholder="$t('candidate.form.last_name.placeholder')"
                    :label="$t('candidate.form.last_name.label') + '*'"
                    v-model="model.last_name"
                    :error="$v.model.last_name.$error"
                    :errorMessage="$v.model.last_name.errorMessage"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <DropDown 
                    :placeholder="$t('candidate.form.gender.placeholder')"
                    :label="$t('candidate.form.gender.label')"
                    :name.sync="model.gender"
                    :options="gender_list" 
                    v-model="model.gender"
                  />
                  <div class="form-group">
                    <label for="">{{$t('candidate.form.summary.label')}}</label>
                    <textarea 
                      class="form-control"
                      :placeholder="$t('candidate.form.gender.placeholder')"
                      v-model="model.summary"
                      rows=10
                    >
                    </textarea>
                  </div>

                  <div class="row">
                    <TextField 
                      class="col-md-6"
                      :placeholder="$t('candidate.form.city.placeholder')"
                      :label="$t('candidate.form.city.label')"
                      v-model="model.city"
                    />
                    <TextField 
                      class="col-md-6"
                      :placeholder="$t('candidate.form.country.placeholder')"
                      :label="$t('candidate.form.country.label')"
                      v-model="model.country"
                    />
                  </div>

                <!-- <DropDown 
                    label="Industry"
                    :name.sync="model.industry"
                    :options="industry_options"
                  /> -->

                </div>
              </div>
              <hr>
              <h5>Contact Information</h5>
              <div class="row">
                <div class="col-md-12">
                  <div class="row">
                    <TextField 
                      class="col-md-6"
                      :placeholder="$t('candidate.form.email.placeholder')"
                      :label="$t('candidate.form.email.label')"
                      v-model="model.email"
                      :error="$v.model.email.$error"
                      :errorMessage="$v.model.email.errorMessage"
                    />
                    <div class="form-group col-md-6">
                      <label for="">{{$t('candidate.form.contact_no.label')}}</label>
                      <input 
                        type="text" 
                        class="form-control"
                        v-model="model.contact_no"
                        :placeholder="$t('candidate.form.contact_no.placeholder')"
                      >
                    </div>

                  </div>
                  <div class="form-group">
                    <label for="">{{$t('candidate.form.date_of_birth.label')}}</label>
                    <flat-pickr
                      v-model="model.date_of_birth"
                      class="form-control"
                      :placeholder="$t('candidate.form.date_of_birth.placeholder')"
                    ></flat-pickr>
                  </div>
                </div>
              </div>
              <button 
                type="submit" 
                class="btn2 btn2-primary btn2-md btn-block"
              ><i class="uil uil-edit mr-1"></i>{{$t('common.save')}}</button>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="card">
          <div class="card-title border-bottom p-3 mb-0 header-title">
            {{$t('candidate.form.working_experience')}}
            <a href="#"
              @click="show = true"
              class="btn btn-primary btn-sm btn-rounded float-right">
              <i class="uil-plus"></i>
            </a>
          </div>
          <div class="card-body" style="max-height:500px;overflow-y:scroll">
            <div class="text-center"
              v-if="model.work_experiences.length == 0"
            >{{$t('candidate.form.empty_working_experience')}}.</div>

            <div class="list-group" 
              v-for="item in model.work_experiences"
              :key="`item-${item.uiid}`"
            >
              <div class="list-group-item mb-2">
                <div>
                  <h5 class="font-size-15 m-0">{{ item.position }}
                    <a href="#"
                      @click="removeExperience( item.uiid )"
                     class="btn btn-danger btn-sm btn-rounded float-right ml-1">
                      <i class="uil-trash"></i>
                    </a>
                    <a href="#"
                      @click="editExperience( item.uiid )"
                     class="btn btn-primary btn-sm btn-rounded float-right">
                      <i class="uil-pen"></i>
                    </a>

                  </h5>
                  <p class="m-0">{{ item.company }} <span class="text-muted">{{ item.employment_type | capitalize  }}</span></p>
                  <p class="text-muted mb-1">{{ item.start_month | capitalize  }} {{ item.start_year }} - {{ (item.present == true ? "Present" : item.end_month) | capitalize }} {{ item.present == true ? "" : item.end_year }}</p>
                  <p class="sub-header" style="white-space: pre-wrap; max-height:200px;overflow-y:scroll">
                    {{ item.description }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-title border-bottom p-3 mb-0 header-title">
            {{$t('candidate.form.educational_background')}}
            <a 
              href="#"
              @click="showEd = true"
              class="btn btn-primary btn-sm btn-rounded float-right">
              <i class="uil-plus"></i>
            </a>
          </div>
          <div class="card-body">
          <div 
            class="text-center"
            v-if="model.education_background.length == 0"
            >{{$t('candidate.form.empty_educational_background')}}.</div>

            <div class="list-group"
              v-for="item in model.education_background"
              :key="`item-${item.uiid}`">
              <div class="list-group-item mb-2">
                <div>
                  <h5 class="font-size-15 m-0">{{ item.school  }} {{ item.school_type | capitalize}}
                    <a href="#"
                      @click="removeEducationBackground( item.uiid )"
                     class="btn btn-danger btn-sm btn-rounded float-right ml-1">
                      <i class="uil-trash"></i>
                    </a>
                    <a 
                      href="#"
                      @click="editEducationBackground( item.uiid  )"
                      class="btn btn-primary btn-sm btn-rounded float-right">
                      <i class="uil-pen"></i>
                    </a>
                  </h5>
                  <p class="m-0">{{ item.degree }}</p>
                  <p class="text-muted mb-1">{{ item.start_year }} - {{ item.end_year }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-title border-bottom p-3 mb-0 header-title">
            {{$t('candidate.form.skills')}}
            <a href="#"
              @click="showSk = true"
               class="btn btn-primary btn-sm btn-rounded float-right">
              <i class="uil-pen"></i>
            </a>
            </div>
            <div class="card-body" style="max-height:300px; overflow-y:scroll">
              <div class="text-center"
                v-if="model.skills.length == 0"
              >{{$t('candidate.form.empty_skills')}}.</div>

              <div class="row icons-list font-size-15"
                
              >
              <span 
                v-for="(item, index) in model.skills"
                :key="`item-${item.uiid}`"
                class="font-weight-bold badge badge-soft-secondary m-2">{{item.name}}
                  <button type="button" class="close" style="font-size: 18px;float: none;"
                    @click="deleteSkill(index, item)">
                      <span>×</span>
                  </button>
                </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal 
      v-model="show" 
      ref="work_experience"
      size="lg" 
      :title="(work_experience.uiid ? 'Edit' : 'Add') + ' Experience'" 
      title-class="font-18">
      <div class="row">
        <div class="col-md-12">
          <TextField 
            placeholder="Enter Position"
            label="Position"
            v-model="work_experience.position"
          />
          <DropDown 
            label="Type"
            :options="employment_type_options"
            :name.sync="work_experience.employment_type"
            v-model="work_experience.employment_type"
          />
          <TextField 
            placeholder="Enter Company"
            label="Company"
            v-model="work_experience.company"
          />
          <TextField 
            placeholder="Enter Country"
            label="Country"
            v-model="work_experience.country"
          />
          <b-form-checkbox
            v-model="work_experience.present"
            class="mb-2">
            I am currently working here
          </b-form-checkbox>
          <div class="row">
            <DropDown 
              label="Start Month"
              class="col-md-3"
              :options="month_options"
              :name.sync="work_experience.start_month"
              v-model="work_experience.start_month"
            />
            <TextField 
              type="number"
              placeholder="Year"
              label="Year"
              class="col-md-3"
              v-model="work_experience.start_year"
            />
            <DropDown 
              label="End Month"
              class="col-md-3"
              :options="month_options"
              :name.sync="work_experience.end_month"
              v-model="work_experience.end_month"
              v-if="!work_experience.present"
            />
            <TextField 
              type="number"
              placeholder="Year"
              label="Year"
              class="col-md-3"
              v-model="work_experience.end_year"
              v-if="!work_experience.present"
            />
          </div>
          <textarea class="form-control" rows="7"
           v-model="work_experience.description"
          ></textarea>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="danger" v-if="work_experience.uiid" @click="removeExperience">Remove</b-button>
        <b-button variant="light" @click="show = false">Close</b-button>
        <b-button variant="primary" @click="addExperience">{{ ( work_experience.uiid ? 'Update' : 'Add') + ' Experience' }}</b-button>
      </template>
    </b-modal>

    <b-modal 
      v-model="showEd" 
      size="lg" 
      ref="education"
      :title="(education.uiid ? 'Edit' : 'Add') + ' Education'" 
      title-class="font-18">
      <div class="row">
        <div class="col-md-12">
          <TextField 
            placeholder="Enter School"
            label="School"
            v-model="education.school"
          />
          <TextField 
            placeholder="Enter Degree"
            label="Degree"
            v-model="education.degree"
          />
          <TextField 
            placeholder="Enter Field of Study"
            label="Field of Study"
            v-model="education.field_of_study"
          />
          <div class="row">
            <TextField 
              type="number"
              placeholder="Year"
              label="Start Year"
              v-model="education.start_year"
              class="col-md-6"
            />
            <TextField 
              type="number"
              placeholder="Year"
              label="End Year"
              v-model="education.end_year"
              class="col-md-6"
            />
          </div>
          <textarea class="form-control" rows="7" placeholder="Enter Description"
           v-model="education.description"
          ></textarea>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="danger" v-if="education.uiid" @click="removeEducationBackground">Remove</b-button>
        <b-button variant="light" @click="showEd = false">Close</b-button>
        <b-button variant="primary" @click="addEducationBackground">{{ ( education.uiid ? 'Update' : 'Add') + ' Education' }}</b-button>
      </template>
    </b-modal>

    <b-modal 
      v-model="showSk" 
      size="lg" 
      ref="skill"
      :title="(skill.uiid ? 'Edit' : 'Add') + ' Skill'" 
      title-class="font-18">
      <div class="row">
        <div class="col-md-12">
          <TextField 
            placeholder="Enter skill"
            label="Skill"
            v-model="skill.name"
          />
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="light" @click="showSk = false">Close</b-button>
        <b-button variant="primary" @click="addSkill">{{ ( skill.uiid ? 'Update' : 'Add') + ' Skill' }}</b-button>
      </template>
    </b-modal>

  </form>
</template>

<script>
import FixedHeader from 'vue-fixed-header'
import { required, email} from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'
import  FormMixin from '@mixins/form'
import TextField from '@components/form/textfield.vue'
import DropDown from '@components/form/dropdown.vue'


export default {
  mixins: [FormMixin],
  data(){
    return {
      model:{
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        confirm_password: '',
        access_type:null,
        recruitment_type:null,
        avatar_path:'',
        work_experiences:[],
        education_background:[],
        skills:[]
      },
      show:false,
      showEd:false,
      showSk:false,
      work_experience:{},
      education:{},
      skill:{},
      gender_list:[
        { value: null, text: 'Please select a Gender' },
        { value: 'Male', text: 'Male' },
        { value: 'Female', text: 'Female' }
      ],
      access_type_options: [
        { value: null, text: 'Please select a Type' },
        { value: 'administration', text: 'Administrator' },
        { value: 'recruitment', text: 'Recruitment' }
      ],
      recruitment_type_options: [
        { value: null, text: 'Please select a Type' },
        { value: 'company', text: 'Company' },
        { value: 'individual', text: 'Individual' }
      ],
      employment_type_options: [
        { value: null, text: '-' },
        { value: 'full-time', text: 'Full-time' },
        { value: 'permanent', text: 'Permenent' },
        { value: 'volunteer', text: 'Volunteer' },
        { value: 'part-time', text: 'Part-time' },
        { value: 'self-employed', text: 'Self-employed' },
        { value: 'freelance', text: 'Freelance' },
        { value: 'contract', text: 'Contract' },
        { value: 'intership', text: 'Internship' },
        { value: 'casual', text: 'Casual' },
        { value: 'labour-hire', text: 'Labour Hire' }
      ],
      month_options : [
        { value: null, text: '-' },
        {value:'january', text:'January'},
        {value:'february', text:'February'},
        {value:'march', text:'March'},
        {value:'april', text:'April'},
        {value:'may', text:'May'},
        {value:'june', text:'June'},
        {value:'july', text:'July'},
        {value:'august', text:'August'},
        {value:'september', text:'September'},
        {value:'october', text:'October'},
        {value:'november', text:'November'},
        {value:'december', text:'December'}
      ],
      fullWidth:document.getElementsByClassName('content-page').item(0).clientWidth
    }
  },
  validations: {
    model:{
      first_name: { required },
      last_name: { required },
      email: {
        required,
        email
      },
    }
  },
  components:{FixedHeader, TextField, DropDown},
  beforeMount(){
    this.fetchData()
  },
  mounted(){
    window.addEventListener('resize', this.handleResize)
  },
  updated(){
    this.handleResize()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    ...mapActions('candidate', ['uploadAvatar', 'findCandidate', 'update',
      'createSkill', 
      'removeSkill',
      'createEducation', 
      'removeEducation',
      'updateEducation',
      'createWorkingExperience', 
      'removeWorkingExperience',
      'updateWorkingExperience',
    ]),
    onAvatarChange(e) {
      let input = e.target

      if (input.files && input.files[0]) {
        this.toggleLoading()
        
        var formData = new FormData();

        formData.append("avatar", input.files[0]);
        formData.append("id", this.$route.query.id);

        this.uploadAvatar(formData).then(res => {

          if(res.data.success == true){
            var reader = new FileReader();

            reader.onload = (a) => {
              this.$refs['imagePreview'].src = a.target.result
              this.toggleLoading()
            }

            reader.readAsDataURL(input.files[0]);
          }else{
            this.toggleLoading()
          }
          
        })
      }

    },
    onViewCandidate() {
      this.$router.push('/candidate/view?id=' + this.$route.query.id)
    },
    addExperience(){
      delete this.work_experience._idx

      if(!this.work_experience.uiid){
        this.work_experience.candidate_id = this.$route.query.id
        this.createWorkingExperience(this.work_experience).then(res => {
          this.model.work_experiences.push(res.data)
        })
      }else{
        this.updateWorkingExperience(this.work_experience).then(res => {
          this.work_experience = res;
        })
      }
      this.work_experience = {}
      this.show = false
    },
    editExperience(uiid){
      this.model.work_experiences.forEach((el, idx) => {
        if(el.uiid == uiid){
          this.work_experience = el
          this.work_experience._idx = idx
          //this.model.work_experiences.splice(idx, 1)
        }
        return false
      });
      this.$refs['work_experience'].show()
    },
    removeExperience(uiid){
      if(!this.work_experience.uiid){
        this.model.work_experiences.forEach((el, idx) => {
          if(el.uiid == uiid){
            this.work_experience = el
            this.work_experience._idx = idx
            //this.model.work_experiences.splice(idx, 1)
          }
          return false
        });
      }
      this.removeWorkingExperience(this.model.work_experiences[this.work_experience._idx]).then(res => {
        if(res.data.ok == 1){
          this.model.work_experiences.splice(this.work_experience._idx, 1)
          this.work_experience = {}
          this.$refs['work_experience'].hide()
        }else{
          alert('Please try again')
        }
      })
    },
    addEducationBackground(){
      delete this.education._idx

      if(!this.education.uiid){
        this.education.candidate_id = this.$route.query.id
        this.createEducation(this.education).then(res => {
          this.model.education_background.push(res.data)
        })
      }else{
        this.updateEducation(this.education).then(res => {
          this.education = res;
        })
      }
      this.education = {}
      this.showEd = false
    },
    editEducationBackground(uiid){

      this.model.education_background.forEach((el, idx) => {
        if(el.uiid == uiid){
          this.education = el
          this.education._idx = idx
          //this.model.educations.splice(idx, 1)
        }
        return false
      });
      this.$refs['education'].show()

    },
    removeEducationBackground(uiid){
      if(!this.education.uiid){
        this.model.education_background.forEach((el, idx) => {
          if(el.uiid == uiid){
            this.education = el
            this.education._idx = idx
            //this.model.education_background.splice(idx, 1)
          }
          return false
        });
      }
      this.removeEducation(this.model.education_background[this.education._idx]).then(res => {
        if(res.data.ok == 1){
          this.model.education_background.splice(this.education._idx, 1)
          this.education = {}
          this.$refs['education'].hide()
        }else{
          alert('Please try again')
        }
      })

    },

    addSkill(){
      delete this.skill._idx

      this.skill.candidate_id = this.$route.query.id
      this.createSkill(this.skill).then(res => {
        this.model.skills.push(res.data)
      })

      this.skill = {}
      this.showSk = false


    },
    deleteSkill(idx, item){
      /* this.model.skills.splice(idx, 1)
      this.skill = {} */

      this.removeSkill(item).then(res => {
        if(res.data.ok == 1){
          this.model.skills.splice(idx, 1)
          this.skill = {}
          this.$refs['education'].hide()
        }else{
          alert('Please try again')
        }
      })
    },
    onSave() {

      if (this.validateForm()) {
				this.toggleLoading()
				return;
			}

      this.update(this.model)
      .then(()=> {
        this.toggleLoading()
        alert('Successfully Save!')
        /* this.$router.push('/candidate/view?id=' + this.$route.query.id) */
      })
      .catch((err) => {
        this.toggleLoading()

        Object.keys(err.response.data).forEach(key => {
          if(this.$v.model[key]) this.$v.model[key].errorMessage = err.response.data[key]
        })

        this.setError(err.response.data.msg)

      })
    },
    async fetchData(){
      await this.findCandidate({
        id:this.$route.query.id
      }).then(data => {
        this.model = data.data
        if(this.model.avatar_path)
        this.$refs['imagePreview'].src = this.model.avatar_path
      })
    },
    handleResize () {
      let header = document.getElementById('sticky-header');
      this.fullWidth = document.getElementsByClassName('content-page').item(0).clientWidth

      if(header){
        header.style.width = this.fullWidth + 'px'
      }
    },
  },
  watch:{
    'model.access_type':{
      handler: function() {
        if(this.model.access_type != 'recruitment_type'){
          this.model.recruitment_type = null
        }
      }
    }
  }
}
</script>

